"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = exports.NOTIFICATION = exports.SIZES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _buttonStyle = require("./button.style.js");

var _global = require("./shared/global.js");

var SIZES = ['large', 'largeDisabled', 'small', 'xsmall', 'fullwidth'];
exports.SIZES = SIZES;
var NOTIFICATION = ['success', 'warning', 'info'];
/**
 * Primary UI component for user interaction
 */

exports.NOTIFICATION = NOTIFICATION;

var Button = function Button(_ref) {
  var type = _ref.type,
      size = _ref.size,
      label = _ref.label,
      disabled = _ref.disabled,
      tab = _ref.tab,
      notification = _ref.notification,
      props = (0, _objectWithoutProperties2.default)(_ref, ["type", "size", "label", "disabled", "tab", "notification"]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_global.GlobalStyle, null), /*#__PURE__*/_react.default.createElement(_buttonStyle.StyledButton, (0, _extends2.default)({
    disabled: disabled,
    type: type,
    size: size,
    tab: tab,
    notification: notification
  }, props), label));
};

exports.Button = Button;
Button.defaultProps = {
  disabled: false,
  size: 'large',
  type: 'button',
  onClick: undefined
};